import React from 'react'
import LoadingBar from 'react-redux-loading-bar'

const Header = () => (
  <header>
    <LoadingBar showFastActions updateTime={500} maxProgress={90} progressIncrease={10} className="loadingBar" />
  </header>
)

export default Header